export default "/34887f8f847f5d202a469a9dd4881160882f8c6b/14ed8dc335eec8ccd043173219a4387f.svg";